module.exports = __webpack_public_path__ + "img/moren.a1ff5796.png";